import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient"; // Importas el que acabamos de crear

export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}